export default "__VITE_ASSET__MobkQY_q__"